import { ProductDetailsDescriptionStyles } from "@guestsupply/Overrides/Widgets/ProductDetails/ProductDetailsDescription";
// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { descriptionStyles } from "@guestsupply/Overrides/Widgets/ProductDetails/ProductDetailsDescription";
import { css } from "styled-components";

descriptionStyles.wrapper = {
    css: css`
        margin-bottom: 0;
        div[data-test-selector="productDetails_htmlContent"] {
            line-height: 21px;
            font-size: 14px;
        }
    `,
};
descriptionStyles.title = {
    css: css`
        margin-bottom: 12px;
    `,
};
